import { Box, Paper, Typography } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';

import { useResetSelectedEmployeeId } from '~/components/SelectedEmployee';
import { useAppearance } from '~/data/appearance';
import { LeftSideMenu } from '~/features/Sidebars/LeftSideMenu';
import { useVisible } from '~/hooks/useVisible';
import { getCurrentLanguage } from '~/localization';
import { AnnouncementsWidget } from '~/scenes/MyWorkspace/components/Widgets';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { SidebarLayout } from '~/scenes/PortalViews/components/SidebarLayout';
import { useCustomBackground } from '~/scenes/PortalViews/Views/PortalHomepage/useCustomBackground';

import { useSxStyles } from './useStyles';

export const PortalHomepage = () => {
  const sxStyles = useSxStyles();

  useResetSelectedEmployeeId();

  const sidebarState = useVisible(true);

  const currentLanguage = getCurrentLanguage();
  const { isLoading: isLoadingAppearance, customAppearance } = useAppearance();

  const { backgroundSettings } = useCustomBackground();

  const { greeting, announcements } = useMemo(() => {
    const greetingTextLocalLang = customAppearance.fGreetingTranslations
      ? customAppearance.fGreetingTranslations.find(
          ({ fLang }) => fLang === currentLanguage,
        )
      : undefined;

    return {
      greeting: {
        isEnabled:
          greetingTextLocalLang && greetingTextLocalLang.fGreetingText !== '',
        text: greetingTextLocalLang?.fGreetingText ?? '',
      },
      announcements: {
        isEnabled: customAppearance.fShowAnnouncement || false,
      },
    };
  }, [customAppearance, currentLanguage]);

  const GreetingBox = () => {
    if (greeting.isEnabled) {
      return (
        <Paper sx={sxStyles.greetingBox}>
          <Typography variant={'h4'}>{greeting.text}</Typography>
        </Paper>
      );
    }

    return <></>;
  };

  if (isLoadingAppearance) {
    return <LoadingView />;
  }

  return (
    <SidebarLayout
      sx={{
        ...backgroundSettings,
      }}
      sidebar={
        <LeftSideMenu
          open={sidebarState.isVisible}
          handleDrawerOpen={sidebarState.show}
          handleDrawerClose={sidebarState.hide}
          routerLink={true}
        />
      }
    >
      <Box sx={sxStyles.pageContent}>
        <GreetingBox />
        {announcements.isEnabled && (
          <Box sx={sxStyles.widgetBox}>
            <AnnouncementsWidget width={500} />
          </Box>
        )}
      </Box>
    </SidebarLayout>
  );
};
